import { render, staticRenderFns } from "./IntranetHomePage.vue?vue&type=template&id=877929ea&"
import script from "./IntranetHomePage.vue?vue&type=script&lang=js&"
export * from "./IntranetHomePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports